module.exports = __webpack_public_path__ + "static/img/gzahh.7201dee.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/MemberCenter/assets/images/gzahh.png
// module id = eMwC
// module chunks = 11